import { Box, BoxProps } from "@chakra-ui/react";

export interface DrawerHeaderProps extends BoxProps {}

export const DrawerHeader = (props: DrawerHeaderProps) => {
  return <Box pb={2} pr={6} {...props} />;
};
